<template>
  <div class="motor-row" :class="{'selected': active}">
    <div class="selection">
      <label for="selectMotor"></label>
      <input
        type="radio"
        :checked="active"
        id="selectMotor"
        name="selectMotor"
        @click="handleSelect"
      >
    </div>
    <div class="cc" v-text="motor.cm_rev"></div>
    <div class="brand" v-text="motor.brand"></div>
    <div class="type justify-content-between pl-3">
      <span class="flex-nowrap">{{ motor.motor_type.label }}</span>
      <template v-if="isMagento">
        <a
            type="button"
            v-if="!isLoggedIn && motor.stp_file_path !== null && !magentoLoggedIn"
            href="/customer/account/login"
            class="download-link"
        >
          <img :src="getImage('3dstepicon.png')" alt="">
        </a>
      </template>
      <template v-else>
        <button
            type="button"
            v-if="motor.stp_file_path !== null && !magentoLoggedIn"
            @click="redirectToLoginModal"
            class="download-link"
        >
          <img :src="getImage('3dstepicon.png')" alt="">
        </button>
      </template>

      <a v-if="magentoLoggedIn || isLoggedIn" class="download-link"
         :href="getStepUrl('motor', this.motor.id)" download>
        <img :src="getImage('3dstepicon.png')" alt="">
      </a>

    </div>
    <div class="continuous-nm" v-text="motor.rated_torque"></div>
    <div class="max-nm" v-text="motor.max_torque"></div>
    <div class="max-rpm" v-text="motor.max_rpm"></div>
    <div class="outgoing-as" v-text="motor.outgoing_as"></div>

    <div class="supply">
      <img
        :src="getImage('check-motor.svg')"
        :id="'supply' + motor.id"
        @mouseenter="hover = true"
        @mouseleave="hover = true"
        v-if="motor.stock >= this.ownValue"
      >
      <img
          :src="getImage('warning.svg')"
        :id="'supply' + motor.id"
        @mouseenter="hover = true"
        @mouseleave="hover = true"
        v-else
      >

      <b-tooltip :show.sync="hover" :target="'supply' + motor.id" placement="top" variant="info" boundary="window">
        <div v-if="motor.stock <= 0">
          {{ motor.delivery_time }}
        </div>
        <div v-else-if="motor.stock >= this.ownValue">
          {{ motor.delivery_message }}
        </div>
        <table class="table table-borderless" style="color: white;" v-else>
          <tr>
            <th width="100" class="text-left">{{ motor.stock }} motors</th>
            <td class="text-left">{{ motor.delivery_message }}</td>
          </tr>
          <tr>
            <th width="100" class="text-left">{{ this.ownValue - motor.stock }} motor{{ (this.ownValue - motor.stock) >
            1 ? 's' : '' }}
            </th>
            <td class="text-left">{{ $t('motor.item.expectedDeliveryTime') }} {{ motor.delivery_time }}</td>
          </tr>
        </table>
      </b-tooltip>
    </div>

    <div class="price">&euro; {{ (motor.price / 100).toFixed(2).replace('.', ',') }}</div>
    <div class="amount-table">
      <div class="actions">
        <button type="button" class="btn btn-success add-to-cart" @click="addToCart(motor); animate($event)">
          <img src="../../../assets/cart-icon.png" alt="">{{ $t('motor.item.add') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import Checkbox from '@/components/input/Checkbox';
import {getStepUrl} from "@/mixins/downloadStepMixin";
import { redirectToLoginModal } from "@/mixins/swalMixin";

export default {
  name: 'MotorItem',
  components: { Checkbox },
  props: {
    motor: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      ownValue: 1,
      hover: false,
    };
  },
  computed: {
    ...mapState({
      magentoLoggedIn: state => state.preference.magentoLoggedIn,
      selectedMotor: state => state.build.motorConfig.preferences.selectedMotor,
    }),
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      isMagento: 'preference/isMagento',
    }),
    active() {
      return this.selectedMotor === this.motor.id;
    },
  },
  mounted() {
    if (this.active) {
      this.selectMotor();
    }
  },
  methods: {
    getStepUrl,
    redirectToLoginModal,
    ...mapActions({
      redirectToLoginUrl: 'auth/redirectToLoginUrl',
    }),
    getIcon() {
      return this.active ? require('../../../assets/check-motor-white.svg') : require(
        '../../../assets/check-motor.svg');
    },
    handleSelect() {
      if (!this.active) {
        this.selectMotor();
      } else {
        this.clearSelectedMotor();
      }
    },
    selectMotor() {
      this.$store.commit('build/motorConfig/selectMotor', this.motor.id);
      this.$store.commit('build/motorConfig/setCc', this.motor.cm_rev);
    },
    clearSelectedMotor() {
      this.$store.commit('build/motorConfig/selectMotor', null);
      this.$store.commit('build/motorConfig/setCc', 0);
    },
    motorconfigStpPath(motor) {
      return process.env.VUE_APP_STORAGE_URL + motor.stp_file_path;
    },
    animate(elem) {
      let tr = elem.target.closest('.motor-row');
      if (!tr.classList.contains('fly')) {
        tr.classList.add('fly');
      }

      setTimeout(() => {
        tr.classList.remove('fly');
      }, 1000);
    },
    addToCart(motor) {
      const { id, article_number } = motor;
      if (this.isMagento) {
        this.$emit('openModal');
        motor.amount = this.ownValue;
        const data = {
          products: {
            [motor.article_number]: motor.amount
          },
          build_id: null,
          build_type: null,
        };
        this.$store.dispatch('cart/sendToMagentoCart', { data, build: motor }).then((order) => {
          order.name = this.translate(order.name);
          this.$store.commit('cart/setCurrentOrder', order);
        }).catch((error) => {
          this.$store.commit('cart/setCurrentOrder', { error: error });
        });
      } else {
        const motorItem = {
          motorId: id,
          articleNumber: article_number,
          amount: this.ownValue,
        };
        this.$store.commit('cart/setCartState', true);
        this.$store.commit('cart/motorConfigItems/setCartItems', motorItem);
        this.$store.dispatch('cart/setCartLocalStorage');
      }
    },
    changeVal(type) {
      if (type === 'decrement' && this.ownValue !== 1) {
        this.ownValue--;
      } else if (type === 'increment') {
        this.ownValue++;
      }
    },
    input(e) {
      let value = e.target.value;
      if (isNaN(e.target.value)) {
        value = 0;
      }
      this.ownValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss">

.fly {
  animation: fly-to-cart 0.85s;
}

.tooltip-inner {
  max-width: 350px;
}

@keyframes fly-to-cart {
  from {
    transition: opacity ease 0.3s;
    background-color: #71BC2D;
  }
  to {
    transition: opacity ease 0.3s;
  }
}

.motor {
  display: block;
  position: relative;
  margin: 0;
  transition: all ease 0.3s;
  cursor: pointer;

  &:not(.active):hover {
    .icon {
      margin-right: 15px;
    }
  }

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    top: 0;
    width: 0;
    transition: all ease 0.3s;
    z-index: 0;
  }

  .icon {
    width: 13px;
    height: 13px;
    margin-right: 10px;
    margin-bottom: 6px;
    transition: all ease 0.3s;
    position: relative;
    z-index: 1;
  }

  .power {
    display: inline-block;
    font-size: 14px;
    font-family: neue-haas-grotesk-text, sans-serif;
    font-weight: 400;
    color: #D7D7D7;
    margin-right: 10px;
    transition: all ease 0.3s;
    position: relative;
    z-index: 1;
  }

  .kwh {
    font-family: neue-haas-grotesk-display, sans-serif;
    color: #D7D7D7;
    transition: all ease 0.3s;
    position: relative;
    z-index: 1;
    font-size: 12px;
  }

  &:after {
    content: '';
    position: absolute;
    right: 15px;
    top: 0;
    bottom: 0;
    width: 8px;
    background: url(../../../assets/arrow-right.svg) no-repeat center;
    background-size: 5px 8px;
    opacity: 0;
    transition: all ease 0.3s;
    z-index: 1;
  }

  &.available {

    .power {
      color: black;
    }

    .kwh {
      color: black;
    }

    &:after {
      opacity: 1;
    }
  }

  &.active {
    letter-spacing: 1px;

    &:before {
      width: 100%;
      background-color: #3DB0C7;
    }

    .power {
      color: #fff;
    }

    .kwh {
      color: #fff;
      font-weight: unset;
    }

    &:after {
      filter: brightness(4);
    }
  }
}

.selection {
  position: relative;

  input[type=radio] {
    position: relative;
    top: 0;
    left: 0;
    cursor: pointer;
    transition: all ease 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  input[type=radio]:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    top: -3px;
    left: -4px;
    background-color: lighten(#3db0c7, 30%);
  }

  input[type=radio]:checked:before {
    content: "";
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: -3px;
    left: -4px;
    background-color: #3db0c7;
  }

  input[type=radio]:checked:after {
    content: "";
    display: block;
    width: 6px;
    height: 12px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 0px;
    left: 3px;
  }
}

input.amount {
  width: 50px;
  border: 0;
  margin: 0 2px;
}

.supply {
  img {
    width: 20px;
    height: 20px;
    cursor: pointer;
    transition: all ease 0.3s;

    &:hover {
      transform: scale(1.2);
    }
  }
}

.popup {
  position: relative;

  .backdrop {
    background-color: rgba(0, 0, 0, .5);
    position: fixed;
    z-index: 3;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  .content {
    box-sizing: border-box;
    padding: 20px 15px;
    background: #fff;
    position: absolute;
    top: -45px;
    left: 12px;
    width: 100vw;
    max-width: 300px;
    min-height: 80px;
    z-index: 99999;
    box-shadow: -2px 0 15px rgba(0, 0, 0, .1);

    &:after {
      content: "";
      display: block;
      height: 10px;
      width: 10px;
      background: inherit;
      position: absolute;
      top: 40px;
      left: 0;
      transform: translateX(-50%) rotate(45deg);
    }

    .text {
      padding: 10px 0;
      display: block;
    }

    .close {
      width: 10px;
      height: 10px;
      position: relative;
      float: right;
      margin-top: -4px;
      cursor: pointer;

      &:before, &:after {
        content: "";
        display: block;
        height: 2px;
        width: 18px;
        background: #a4afb7;
        position: absolute;
        top: 50%;
        left: 50%;
      }

      &:before {
        transform: translateX(-50%) translateY(-50%) rotate(45deg);
      }

      &:after {
        transform: translateX(-50%) translateY(-50%) rotate(-45deg);
      }
    }
  }
}

</style>
